module.exports = __webpack_public_path__ + "static/media/bg_02.95025454.png";